<template>
  <div class="app-container" v-loading="fetchLoading">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="top_nav" type="border-card">
      <!-- 必报列表 -->
      <el-tab-pane label="必报列表" name="first">
        <div class="top_btns clearfix">
          <div class="fr">
            <qzf-button @success="generalTax" size="mini" type="success" plain>取数</qzf-button>
            <qzf-button @success="getList" size="mini" type="primary" plain>刷新</qzf-button>
            <qzf-button @success="shenbao" size="mini" type="primary" plain>申报</qzf-button>
            <qzf-button @success="handleSubject" size="mini" type="primary" plain>计提科目设置</qzf-button>
            <settings :name="settingName" :type="['code_jjdj','code_jjdj_subject_code','code_sffgs','code_xgmdkfpbjsfjs','code_jjdj_kcs','code_jm_tax','code_vat_bc','code_vat_ckts','code_yhsfu','code_yh_in','code_qysds','code_gxqy','code_sds_ms','code_fgs','code_ghjf','code_ghjf_gz', ]"></settings>
          </div>
        </div>
        <el-table stripe size="mini" :header-cell-style="{background: '#eee',color:'#333','font-size': '12px'}" :data="list" style="width: 100%;" v-loading="loading" border :height="contentStyleObj" @selection-change="handleSelectionChange">
          <el-table-column prop="name" type="selection" width="35" align="center"></el-table-column>
          <el-table-column prop="name" label="申报列表名称" min-width="250">
            <template #default="scope">
              <span>{{$tableNameFilter(scope.row.tableName)}}</span>
              <!-- <span style="margin-left:10px;color:#39b0d2;cursor:pointer" @click="declareDetail(scope.row)">申报详情</span>
              <span style="margin-left:10px;color:#39b0d2;cursor:pointer" @click="deductionDetail(scope.row)">扣款详情</span> -->
            </template>
          </el-table-column>
          <el-table-column prop="name" label="取数状态" align="center" min-width="90">
            <template #default="scope">
              <div class="item_icon" v-if="scope.row.status == 1">
                <i class="el-icon-success"></i>
                <p>已取数</p>
              </div>
              <div class="item_icon" v-else>
                <i class="el-icon-warning"></i>
                <p>未取数</p>
              </div>
            </template>
          </el-table-column>
           <el-table-column prop="name" label="取数时间" min-width="155" align="center">
            <template #default="scope">
              <span>{{$parseTime(scope.row.createdAt,'{y}-{m}-{d} {h}:{i}:{s}')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="taskStatus" label="申报状态" align="center" min-width="220">
            <template #default="scope">
              <el-tooltip placement="top" :disabled="scope.row.errLog == ''" v-if="scope.row.tableName == 'gs_gs'">
                <div class="item_icon">
                  <span v-if="scope.row.image" class="demo-image__preview" >
                    <i class="el-icon-picture" style="color:#409eff;font-size:16px;" @click="open(scope.row, scope.$index)"></i>
                  </span>
                  <p v-if="scope.row.taskStatus == '0'">
                    <i v-if="!scope.row.image" class="el-icon-warning"></i>{{$setUpStatusGsSb(scope.row.taskStatus)}}
                  </p>
                  <p v-if="scope.row.taskStatus == '1'">
                    <i v-if="!scope.row.image" class="el-icon-info"></i>{{$setUpStatusGsSb(scope.row.taskStatus)}}
                  </p>
                  <p v-if="scope.row.taskStatus == '2'">
                    <i v-if="!scope.row.image" class="el-icon-success"></i>
                    <el-tooltip v-if="scope.row.errLog" class="item" effect="dark" :content="scope.row.errLog" placement="top-start">
                      <el-button size="mini" class="sbcg" style="border: 0;">{{$setUpStatusGsSb(scope.row.taskStatus)}}</el-button>
                    </el-tooltip>
                    <span v-else><el-button size="mini" class="sbcg" style="border: 0;">{{$setUpStatusGsSb(scope.row.taskStatus)}}</el-button></span>
                  </p>
                  <p v-if="scope.row.taskStatus == '3'"><i v-if="!scope.row.image" class="el-icon-error"></i>
                    <el-tooltip v-if="scope.row.errLog" class="item" effect="dark" :content="scope.row.errLog" placement="top-start">
                      <el-button size="mini" class="sbcg" style="border: 0;">{{$setUpStatusGsSb(scope.row.taskStatus)}}</el-button>
                    </el-tooltip>
                    <span v-else><el-button size="mini" class="sbcg" style="border: 0;">{{$setUpStatusGsSb(scope.row.taskStatus)}}</el-button></span>
                  </p>
                  <p v-if="scope.row.taskStatus == '4'"><i v-if="!scope.row.image" class="el-icon-error"></i>
                    <el-tooltip v-if="scope.row.errLog" class="item" effect="dark" :content="scope.row.errLog" placement="top-start">
                      <el-button size="mini" class="sbyc" style="border: 0;">{{$setUpStatusGsSb(scope.row.taskStatus)}}</el-button>
                    </el-tooltip>
                    <span v-else><el-button size="mini" class="sbyc" style="border: 0;">{{$setUpStatusGsSb(scope.row.taskStatus)}}</el-button></span>
                  </p>
                  <p v-if="scope.row.taskStatus == '5'"><i v-if="!scope.row.image" class="el-icon-error"></i>{{$setUpStatusGsSb(scope.row.taskStatus)}}</p>
                  <p v-if="scope.row.taskStatus == '6'"><i v-if="!scope.row.image" class="el-icon-error"></i>{{$setUpStatusGsSb(scope.row.taskStatus)}}</p>
                  <p v-if="scope.row.taskStatus == '7'"><i v-if="!scope.row.image" class="el-icon-success"></i>{{$setUpStatusGsSb(scope.row.taskStatus)}}</p>
                  <p v-if="scope.row.taskStatus == '8'"><i v-if="!scope.row.image" class="el-icon-info"></i>{{$setUpStatusGsSb(scope.row.taskStatus)}}</p>
                  <p v-if="scope.row.taskStatus == '10'"><i v-if="!scope.row.image" class="el-icon-success"></i>{{$setUpStatusGsSb(scope.row.taskStatus)}}</p>
                  <p v-if="scope.row.taskStatus == '11'"><i v-if="!scope.row.image" class="el-icon-info"></i>{{$setUpStatusGsSb(scope.row.taskStatus)}}</p>
                  <p v-if="scope.row.taskStatus == '12'"><i v-if="!scope.row.image" class="el-icon-error"></i>
                  <el-tooltip v-if="scope.row.errLog" class="item" effect="dark" :content="scope.row.errLog" placement="top-start">
                    <el-button size="mini" class="sbyc" style="border: 0;">{{$setUpStatusGsSb(scope.row.taskStatus)}}</el-button>
                  </el-tooltip>
                  <span v-else><el-button size="mini" class="sbyc" style="border: 0;">{{$setUpStatusGsSb(scope.row.taskStatus)}}</el-button></span>
                  </p>
                  <p v-if="scope.row.taskStatus == '13'"><i v-if="!scope.row.image" class="el-icon-success"></i>{{$setUpStatusGsSb(scope.row.taskStatus)}}</p>
                  <p v-if="scope.row.taskStatus == '14'"><i v-if="!scope.row.image" class="el-icon-info"></i>{{$setUpStatusGsSb(scope.row.taskStatus)}}</p>
                </div>
              </el-tooltip>
              <el-tooltip placement="top" :disabled="scope.row.errLog == ''" v-else-if="scope.row.taskStatus">
                <template #content> {{scope.row.errLog}} </template>
                <div class="item_icon" v-if="scope.row.taskStatus == '0'">
                  <i class="el-icon-warning"></i>
                  <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                </div>
                <div class="item_icon" v-else-if="scope.row.taskStatus == '1'">
                  <i class="el-icon-info"></i>
                  <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                </div>
                <div class="item_icon" v-else-if="scope.row.taskStatus == '2'">
                  <i class="el-icon-info"></i>
                  <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                </div>
                <div class="item_icon" v-else-if="scope.row.taskStatus == '3'">
                  <i class="el-icon-success"></i>
                  <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                </div>
                <div class="item_icon" v-else-if="scope.row.taskStatus == '4'">
                  <i class="el-icon-error"></i>
                  <p style="color:red">{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                </div>
                <div class="item_icon" v-else-if="scope.row.taskStatus == '5'">
                  <!-- <i class="el-icon-info"></i> -->
                  <el-button :loading="true" type="text">{{ $setUpStatusSb(scope.row.taskStatus) }}</el-button>
                </div>
                <div class="item_icon" v-else-if="scope.row.taskStatus == '6'">
                  <i class="el-icon-success"></i>
                  <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                </div>
                <div class="item_icon" v-else>
                  <i class="el-icon-warning"></i>
                  <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                </div>
              </el-tooltip>
              <el-tooltip placement="top" :disabled="scope.row.errLog == ''" v-else :loading="true">
                <div class="item_icon">
                  <i class="el-icon-warning"></i>
                  <p>{{ $setUpStatusSb(scope.row.taskStatus) }}</p>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="申报详情" min-width="80" align="center">
            <template #default="scope">
              <span style="color:#39b0d2;cursor:pointer" @click="declareDetail(scope.row)">点击查看</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="扣款状态" align="center" min-width="90">
            <template #default="scope">
              <el-tooltip placement="top" :disabled="scope.row.errLog2 == ''" v-if="scope.row.taskStatus2">
                <template #content> {{scope.row.errLog2}} </template>
                <div class="item_icon" v-if="scope.row.taskStatus2 == '0'">
                  <i class="el-icon-warning"></i>
                  <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                </div>
                <div class="item_icon" v-else-if="scope.row.taskStatus2 == '1'">
                  <i class="el-icon-info"></i>
                  <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                </div>
                <div class="item_icon" v-else-if="scope.row.taskStatus2 == '2'">
                  <i class="el-icon-info"></i>
                  <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                </div>
                <div class="item_icon" v-else-if="scope.row.taskStatus2 == '3'">
                  <i class="el-icon-success"></i>
                  <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                </div>
                <div class="item_icon" v-else-if="scope.row.taskStatus2 == '4'">
                  <i class="el-icon-info"></i>
                  <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                </div>
                <div class="item_icon" v-else-if="scope.row.taskStatus2 == '5'">
                  <i class="el-icon-error"></i>
                  <p style="color:red">{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                </div>
              </el-tooltip>
              <el-tooltip placement="top" :disabled="scope.row.errLog2 == ''" v-else>
                <div class="item_icon">
                  <i class="el-icon-warning"></i>
                  <p>{{ $setUpStatusKk(scope.row.taskStatus2) }}</p>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="扣款详情" min-width="80" align="center">
            <template #default="scope">
              <span style="color:#39b0d2;cursor:pointer" @click="deductionDetail(scope.row)">点击查看</span>
            </template>
          </el-table-column>
         
          <el-table-column prop="name" label="税款" align="center" min-width="80">
            <template #default="scope">
              <span>{{scope.row.tax}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="税负率" align="center" min-width="60">
            <template #default="scope">
              <span>{{scope.row.sf}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="年税负率" align="center" min-width="80">
            <template #default="scope">
              <span>{{scope.row.sfYear}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" class-name="top_right_btns" min-width="150">
            <template #default="scope">
              <div class="item_icon" @click="editTax(scope.row)" v-if="scope.row.tableName != 'gs_gs_one'">
                <i class="el-icon-view"></i>
                <p style="color:#39b0d2">查看</p>
              </div>
              <div class="item_icon" v-if="scope.row.tableName != 'gs_gs_one' && scope.row.tableName != 'gs_gs' && scope.row.tableName != 'gs_cwbb'">
                <el-button size="mini" type="text" @click="fetchNumber(scope.row)"><i class="el-icon-s-help"></i>取数</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- 必报列表 end -->
    </el-tabs>
  </div>
  <provision ref="provision"></provision>
  <declareDetails ref="declareDetails"></declareDetails>
  <sbImgUrl ref="sbImgUrl"></sbImgUrl>

</template>

<script>
import { taxList , taxCreate } from "@/api/taxCalculation"
import provision from './vat-invoice/component/provision.vue'
import declareDetails from "../../batch/components/declareDetails.vue"
import { sendTask } from "@/api/collection"
import sbImgUrl from "../../batch/components/sbImgUrl.vue"

export default {
  name:'tax',
  components: { 
    provision,
    declareDetails,
    sbImgUrl },
  data() {
    return {
      list:[],
      activeName:'first',
      loading:false,
      fetchLoading:false,
      period:this.$store.getters['user/comInfo'].period,
      gsMainIds:undefined
    }
  },
  created(){
    this.getList()
    this.contentStyleObj= this.$getHeight(300)
  },
  methods:{
    editTax(row){
      if(row.status != 1){
        this.$qzfMessage("请先取数", 1)
        return
      }
      // this.$router.push({
      //   // path: "/report/smallVat",  //小规模
      //   // path: "/report/qysds",     //企业所得税
      //   path: "/report/vatInvoice",   //一般纳税人
      // });
      if(row.tableName == 'kj_lrb'|| row.tableName == 'kj_zcfz'|| row.tableName == 'gs_cwbb'){
          this.$router.push({
          path: "/report/finance",   //会计报表
        });
      }else if(row.tableName == 'gs_vat'){
          this.$router.push({
          path: "/report/vatInvoice",   //增值税报表 一般纳税人
        });
      }else if(row.tableName == 'gs_small_vat'){
          this.$router.push({
          path: "/report/smallVat",   //增值税报表 小规模
        });
      }else if(row.tableName == 'gs_tax_quarter'){
          this.$router.push({
          path: "/report/qysds",   //企业所得税
        });
      }else if(row.tableName == 'gs_deed'){
          this.$router.push({
          path: "/report/propertyTax",   //财产和行为纳税申报表
        });
      }else if(row.tableName == 'gs_qtsr'){
          this.$router.push({
          path: "/report/taxNeimengQtsr",   //其他收入
        });
      }else if(row.tableName == 'gs_sl'){
          this.$router.push({
          path: "/report/taxNeimengSl",   //水利建设专项收入
        });
      }else if(row.tableName == 'gs_ljcl'){
          this.$router.push({
          path: "/report/taxCityLife",   //城市生活垃圾处置费
        });
      }else if(row.tableName == 'gs_xfs'){
          this.$router.push({
          path: "/report/xfs",   //城市生活垃圾处置费
        });
      }else if(row.tableName == 'gs_cbj'){
          this.$router.push({
          path: "/report/cbj",   //残疾人就业保障金申报表
        });
      }else if(row.tableName == 'gs_whsyjsfsbbygz'){
          this.$router.push({
          path: "/report/culturalTax",   //残疾人就业保障金申报表
        });
      }else if(row.tableName == 'gs_gs'){
          this.$router.push({
          path: "/report/normal",   //综合所得个人所得税预扣预缴申报表
        });
      }
    },
    handleSubject() {
      this.$refs.provision.openDialog()
    },
    handleSelectionChange(row) {
      this.gsMainIds = []
      row.map(info=>{
        // this.gsMainIds.push({gsMainId: item.gsMainId, gsMainStatus: item.gsMainStatus})
        this.gsMainIds.push(info.id)
      })
    },
    //申报
    shenbao() {
      if(!this.gsMainIds){
        this.$qzfMessage("请选择公司", 1)
        return
      }
      let param = {
        taskName: 'tax_sb',
        gsMainIds: this.gsMainIds
      }
      sendTask(param).then(res => {
        if(res.data.msg == 'success') {
          this.$qzfMessage('任务已发起',3)
          this.getList()
        }
      })
    },
    getList() {
      this.fetchLoading = true
      taxList({}).then(res=>{
        this.fetchLoading = false
        if(res.data.data.list){
          this.list = res.data.data.list
        }else{
          this.list = []
        }      
      })
    },
    // 取数
    fetchNumber(row){
      this.fetchLoading = true
      taxCreate({tableName:row.tableName}).then(res=>{
        this.fetchLoading = false
        if(res.data.msg == "success"){
          this.getList();
          this.$qzfMessage("取数成功")
          this.$bus.emit('voucherUpdate')
        }
      })
    },
    generalTax(){
      this.fetchLoading = true
      taxCreate({}).then(res=>{
        this.fetchLoading = false
        if(res.data.msg == "success"){
          this.getList()
          this.$bus.emit('voucherUpdate')
          this.$qzfMessage("操作成功")
        }
      })
    },
    declareDetail(e) {
      this.$refs.declareDetails.init(e.comId,this.period,e.taskName)
    },
    deductionDetail(e) {
      this.$refs.declareDetails.init(e.comId,this.period,e.taskName2)
    },
    // 个税申报图展示
    open(row, index) {
      let imageAll = []
      this.list.map(res => {
        let url = {
          name: res.name,
          url: ""
        }
        url.url = res.image ? 'https://file.qizhangfang.net' + res.image + "?" + Math.random(10): ""
        imageAll.push(url)
      })
      this.$refs.sbImgUrl.dialog(imageAll, index)
    },
  }
}
</script>

<style lang="scss" scoped>
.top_right_btns {
  i {
    // margin: 0 5px;
    cursor: pointer;
    color: $color-main;
    font-size: 18px;
    // line-height: 24px;
  }
  div{
    margin-right:5px
  }
}
.top_btns {
  margin-bottom: 10px;
  position: fixed;
  top: 103px;
  right: 55px;
  z-index: 999;
}
.item_icon{
  display: inline-block;
  cursor: pointer;
  i{
    display: inline-block;
    line-height: 28px;
    font-size: 16px;
  }
  .el-icon-error{
    color: #f56c6c;
  }
  .el-icon-success{
    color: #67c23a;
  }
  .el-icon-circle-check{
    color: #67c23a;
  }
  .el-icon-info{
    color: #409eff
  }
  .el-icon-warning{
    color: #e6a23c;
  }
  .el-icon-warning-outline{
    color: #e6a23c;
  }

  p{
    display: inline-block;
    font-size: 14px;
    line-height: 28px;
    color: #333;
  }
}
// .el-table{
//   /deep/ th {
//     padding: 0px;
//   }
//   /deep/ td {
//     padding: 0px;
//   }
// }
</style>